import { fetchBaseQuery } from "@reduxjs/toolkit/query";

export const BaseURL = import.meta.env.VITE_BASE_URL;

export const getBaseUrl = () => BaseURL;

export const createServerSideRequestOption = async ({
  request,
  url,
  method,
  body,
  validateCookiePresence = true,
}: {
  request: Request;
  url: string;
  body?: any;
  method: serverSideHttpMethod;
  validateCookiePresence?: boolean;
}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const cookies = request.headers.get("cookie");
  if (cookies) {
    myHeaders.append("cookie", cookies);
  } else if (validateCookiePresence) throw new Error("User not logged in");

  const requestOptions: any = {
    method: method,
    headers: myHeaders,
    credentials: "include",
  };

  if (body) {
    requestOptions["body"] = JSON.stringify(body);
  }
  return await fetch(url, requestOptions);
};

export const createBaseQuery = (path: string = "") => {
  return fetchBaseQuery({
    baseUrl: `${BaseURL}/api/v1${path}`,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("content-type", "application/json");
      headers.set("accept", "*");

      return headers;
    },
  });
};
